import { Box, Swiper, useBreakpointProp } from '@bonanza-social/moonlight';
import { memo, useMemo } from 'react';
import ShopSaleBannerOverlay from '../ShopSaleBannerOverlay/ShopSaleBannerOverlay';
import { useShopSales } from '../../hooks';
import { ShopSaleSwiperItem } from '../../state/sales/sales.types';

function ShopSaleBanners() {
  const { shopSales } = useShopSales();

  const items = useMemo(() => {
    if (!shopSales) return;

    return shopSales.reduce<ShopSaleSwiperItem[]>((acc, sale) => {
      if (sale.bannerImage) {
        acc.push({
          ...sale,
          image: sale.bannerImage,
        });
      }
      return acc;
    }, []);
  }, [shopSales]);

  const showArrows = useBreakpointProp({
    mobile: false,
    tablet: false,
    desktop: true,
  });

  if (!items?.length) return null;

  return (
    <Box
      overflow="hidden"
      borderRadius={{
        mobile: 'radius-0',
        tablet: 'radius-0',
        desktop: 'radius-200',
      }}
    >
      <Swiper<ShopSaleSwiperItem>
        items={items}
        renderOverlayItem={(sale) => <ShopSaleBannerOverlay sale={sale} />}
        imageContentFit="cover"
        height={128}
        width="100%"
        autoplay
        pagination
        arrows={showArrows}
      />
    </Box>
  );
}

export default memo(ShopSaleBanners);
